import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const Navbar = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleAuthClick = () => {
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/signin');
    }
  };

  return (
    <nav className="w-full bg-white border-b border-gray-200" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_blog-56/artifacts/ar7lcvoq_WhatsApp%20Image%202026-02-21%20at%2022.08.34.jpeg" 
            alt="Badminton Stats Logo" 
            className="h-16 w-auto"
          />
          <span className="ml-3 text-2xl font-bold text-blue-600">Badminton Stats</span>
        </Link>

        {/* Center Links */}
        <div className="hidden md:flex items-center gap-6">
          <Link to="/features" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-testid="nav-features-link">
            Features
          </Link>
          <Link to="/leaderboard" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-testid="nav-leaderboard-link">
            Leaderboard
          </Link>
          <Link to="/blog" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-testid="nav-blog-link">
            Blog
          </Link>
          <Link to="/features#ai-coach" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-testid="nav-ai-coach-link">
            AI Coach
          </Link>
          <Link to="/privacy" className="text-sm text-gray-500 hover:text-blue-600 transition-colors">
            Privacy
          </Link>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-3">
          <Button 
            onClick={handleAuthClick}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 text-lg"
            data-testid="auth-btn"
          >
            {user ? 'Dashboard' : 'Sign In'}
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
